/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.05.2016.
 */

import React, {Component, PropTypes} from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import {VelocityComponent} from 'velocity-react';
import Classnames from 'classnames';

import _get from 'lodash/get';

class ChannelRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-channel-logo-64x64.png`
    }
  }

  shouldComponentUpdate(nextProps, nextState) {

    return shallowCompare(this, nextProps, nextState);
  }

  componentDidMount() {

    lh.models.channelAsset.methods.getPosterUrl(this.props.channel, {crop: {x: 64, y: 64}})
      .then((url) => {
        this.setState({picture: url});
      });
  }

  _handlerExtend = () => {
    this.props.onExtendRow(this.props.row, this.props.channel);
  };

  _renderCatchUpIcon() {
    if (_get(this.props.channel, 'is_catchup2_available')) {
      return (
        <span className="icon">
        <i className="ic ic-11px ic-catchup2"></i>
        </span>
      );
    }

    if (_get(this.props.channel, 'is_catchup_available')) {
      return (
        <span className="icon">
        <i className="ic ic-11px ic-catchup"></i>
        </span>
      );
    }
  }

  render() {
    if (this.props.needToHide) {
      return (<div className="blocks-epg radius clearfix channel-row" style={{height: this.props.isExtend ? 339 : 63}}></div>);
    }

    let animationOnExpand = {
      marginTop: this.props.isExtend ? 0 : '-270px',
      marginBottom: this.props.isExtend ? '6px' : 0
    };

    let animationProfileContainer = {
      height: this.props.isExtend ? 339 : 63
    };

    return (
      <VelocityComponent animation={animationProfileContainer} duration={350}>
        <div className="blocks-epg radius clearfix channel-row">
          <VelocityComponent animation={animationOnExpand} duration={350}>
            <div className="showcase-expanded-profile" id="showcase_expanded_tile"></div>
          </VelocityComponent>
          <div className="block-channel radius" onClick={this._handlerExtend}>
            <a className="pad-lr hover">
              <div className="block-note">
                <img src={this.state.picture} className="ico-channel" alt="" />
              </div>
              <div className="block-note channel-desc mv">
                <div className="channel-icons display-block">
                  {_get(this.props.channel, 'is_favorite') && <span className="icon mr"><i className="ic ic-11px ic-fav-in-fill"></i></span> }
                  {this._renderCatchUpIcon()}
                </div>
                <div className="display-block"><strong>{_get(this.props.channel, 'title', '')}</strong></div>
                {_get(Config, 'epg.show_lcn') && <div className="display-block">{_get(this.props.channel, 'er_lcn', '')}</div>}
              </div>
            </a>
          </div>
        </div>
      </VelocityComponent>
    );
  }
}

ChannelRow.propTypes = {
  channel: PropTypes.object,
  onExtendRow: PropTypes.func.isRequired
};

ChannelRow.defaultProps = {
  channel: {}
};

export default ChannelRow



// WEBPACK FOOTER //
// ./src/components/EPGGrid/epg-grid-chanel-row.js